import * as ACTION_TYPES from "../actions/action_types";

export const initialState = {
  customer: "NoCustomer",
};

export const CustomerReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.SET_CUSTOMER:
      return {
        ...state,
        customer: action.payload,
      };
    case ACTION_TYPES.FAILURE:
      return {
        ...state,
        customer: "FAILURE",
      };
    default:
      return state;
  }
};
